export default "<div *ngIf=\"examInfoTemplate\">\r\n\t<span *ngIf=\"examInfoTemplate.template_body\"></span>\r\n</div>"